"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _lodash2 = _interopRequireDefault(require("lodash.omit"));

var _reactSortableHoc = require("react-sortable-hoc");

var _commonReact = require("@devsta/common-react");

var _GridClip = _interopRequireDefault(require("./GridClip"));

var _ListClip = _interopRequireDefault(require("./ListClip"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SortableClip = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var props = _ref.value;
  var ClipComponent = props.clipsView === 'GRID' ? _GridClip.default : _ListClip.default;
  return (/*#__PURE__*/_react.default.createElement(ClipComponent, props)
  );
});

var Clip = /*#__PURE__*/function (_Component) {
  _inherits(Clip, _Component);

  var _super = _createSuper(Clip);

  function Clip() {
    var _this;

    _classCallCheck(this, Clip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function () {
      var onDragOver = _this.props.onDragOver;

      if (_this._blockDragOvers || !onDragOver) {
        return;
      }

      _this._blockDragOvers = true;
      setTimeout(function () {
        _this._blockDragOvers = false;
      }, 300);
      onDragOver();
    });

    _defineProperty(_assertThisInitialized(_this), "getCommentQuantityForAsset", function () {
      var _this$props = _this.props,
          comments = _this$props.comments,
          clipId = _this$props.clip.clipId,
          assetId = _this$props.assetId;
      return comments.filter(function (_ref2) {
        var commentClipId = _ref2.clipId,
            commentAssetId = _ref2.assetId;

        if (commentClipId && commentClipId === clipId) {
          return true;
        }

        return assetId === commentAssetId;
      }).length;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteClip", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, clipId, onRemoveClip, comments, deleteComment, commentIds;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, clipId = _this$props2.clip.clipId, onRemoveClip = _this$props2.onRemoveClip, comments = _this$props2.comments, deleteComment = _this$props2.deleteComment;
              commentIds = comments.filter(function (_ref4) {
                var commentClipId = _ref4.clipId;
                return commentClipId === clipId;
              }).map(function (_ref5) {
                var commentId = _ref5.commentId;
                return commentId;
              });
              _context.next = 4;
              return Promise.all(commentIds.map(function (commentId) {
                return deleteComment({
                  commentId: commentId
                });
              }));

            case 4:
              onRemoveClip(clipId);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    return _this;
  }

  _createClass(Clip, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var asset = this.props.asset; // We only need to update when the asset gets set for the first time.

      return nextProps.asset && !asset || !(0, _lodash.default)((0, _lodash2.default)(nextProps, 'asset'), (0, _lodash2.default)(this.props, 'asset'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          clip = _this$props3.clip,
          onSelectClip = _this$props3.onSelectClip,
          onChangeClipIndex = _this$props3.onChangeClipIndex,
          selectedClipId = _this$props3.selectedClipId,
          clipsLength = _this$props3.clipsLength,
          index = _this$props3.index,
          clipsView = _this$props3.clipsView,
          isOver = _this$props3.isOver,
          position = _this$props3.position,
          asset = _this$props3.asset,
          canUpdateVideo = _this$props3.canUpdateVideo;
      return (/*#__PURE__*/_react.default.createElement(SortableClip, {
          key: clip.clipId,
          index: index,
          disabled: !canUpdateVideo,
          value: _objectSpread({}, clip, {
            isOver: isOver,
            selected: selectedClipId === clip.clipId,
            onSelect: onSelectClip(clip.clipId),
            onChangeIndex: onChangeClipIndex(clip.clipId),
            index: index,
            clipsLength: clipsLength,
            clipId: clip.clipId,
            clipsView: clipsView,
            position: position,
            onRemoveClip: this.handleDeleteClip,
            onDragEnter: this.handleDragOver,
            asset: asset,
            canUpdateVideo: canUpdateVideo,
            commentsQuantity: this.getCommentQuantityForAsset()
          })
        })
      );
    }
  }]);

  return Clip;
}(_react.Component);

var _default = (0, _commonReact.withAssetSelector)(Clip);

exports.default = _default;